import React, { useState, useRef, useContext } from 'react'
import axios from 'axios'
import {
  Form,
  FormGroup,
  FormLabel,
  FormControl,
  Button,
} from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import config from '../../config/config'
import { useAuth, AuthContext } from '../../contexts/AuthContext'
import { setFlashMessage, useWebsite } from '../../contexts/WebsiteContext'
import { LOGIN_PATH } from '../../config/routes'

const ManagePoiAddInternalLink = ({ poi, handleAddLink }) => {
  const { t } = useTranslation()
  const { token } = useAuth()
  const navigate = useNavigate()
  const { logout } = useContext(AuthContext)

  const [searchText, setSearchText] = useState('')
  const [searchResults, setSearchResults] = useState([])
  const [formData, setFormData] = useState({
    linkedPoiId: null,
    linkedPoiLabel: '',
  })
  const inputRef = useRef(null)

  const handleSearchInputChange = async (event) => {
    const text = event.target.value
    setSearchText(text)
    if (text.trim() !== '' && text.trim().length >= 3) {
      try {
        const response = await axios.get(
          `${config.apiUrl}poi?autocomplete=${text}`,
        )
        setSearchResults(response.data)
      } catch (error) {
        setFlashMessage(t('ERROR_MESSAGE'), 'error')
        console.error('An error occurred GET poi', text)
      }
    } else {
      setSearchResults([])
    }
  }

  const handleSelectPoi = (id, label) => {
    setFormData({ linkedPoiId: id, linkedPoiLabel: label })
    setSearchText('')
    setSearchResults([])
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    try {
      await axios.post(
        `${config.apiUrl}poi-internal-link`,
        {
          poiId: poi.id,
          linkedPoiId: formData.linkedPoiId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )

      // Clear form data
      setFormData({ linkedPoiId: null, linkedPoiLabel: '' })

      setFlashMessage(t('SUCCESS_CREATED_MESSAGE'), 'success')
      handleAddLink()
    } catch (error) {
      //console.error('Error webservice call:', error);

      if (error.response && error.response.status === 401) {
        logout()
        navigate(LOGIN_PATH)
      } else if (error.response) {
        setFlashMessage(t('ERROR_MESSAGE'), 'error')
        console.error('POST poi-internal-link:', poi.id)
      }
    }
  }

  return (
    <div>
      <h2>{t('ADD')}</h2>
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <FormLabel>Poi à relier</FormLabel>
          <div className="green-frame" style={{ paddingBottom: '10px' }}>
            {formData.linkedPoiLabel
              ? formData.linkedPoiLabel
              : t('SELECT_AUTOCOMPLETE_MESSAGE')}
          </div>
        </FormGroup>
        <FormGroup>
          <FormLabel>Rechercher un POI à relier</FormLabel>
          <FormControl
            type="text"
            name="linkedPoi"
            value={searchText}
            onChange={handleSearchInputChange}
            ref={inputRef}
          />
          {searchResults.length > 0 && (
            <ul>
              {searchResults.map((poi) => (
                <li
                  key={poi.id}
                  onClick={() => handleSelectPoi(poi.id, poi.labelFr)}
                >
                  {poi.labelFr}
                </li>
              ))}
            </ul>
          )}
        </FormGroup>
        <div
          className="text-center margin-top-20"
          style={{ marginBottom: '60px' }}
        >
          <Button type="submit" disabled={!formData.linkedPoiId}>
            {t('ADD')}
          </Button>
        </div>
      </Form>
    </div>
  )
}

export default ManagePoiAddInternalLink
